import React from 'react';
import Avatar from 'src/components/Avatar';
import './SelectedContactCard.scss';

interface SelectedContactCardProps {
  name: string;
  role: string;
  profileImage: string | null;
  badge: 'service-provider' | 'property-manager';
}

const SelectedContactCard = ({
  name,
  role,
  profileImage,
  badge,
}: SelectedContactCardProps) => {
  return (
    <div className="selected-contact-card">
      <div className="selected-contact-card-avatar">
        <Avatar badge={badge} url={profileImage} size={undefined} />
      </div>

      <div className="selected-contact-card-text">
        <div className="selected-contact-card-name">{name}</div>
        <div className="selected-contact-card-role">{role}</div>
      </div>
    </div>
  );
};

export default SelectedContactCard;
